export function isObject(item: unknown): item is object {
  return !Array.isArray(item) && typeof item === 'object';
}
